import React from 'react';
import { startGoogleAuth } from '../services/api';

interface LoginPageProps {
  error?: string | null;
}

const LoginPage: React.FC<LoginPageProps> = ({ error }) => {
  const handleLogin = () => {
    startGoogleAuth();
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Google Drive Task Manager</h1>
      </header>
      <main className="login-container">
        <h2>Sign In</h2>
        <p>Please sign in to access Google Drive and start tasks.</p>
        <button className="button" onClick={handleLogin}>
          Sign in with Google
        </button>
        {error && <div className="error-message">{error}</div>}
      </main>
    </div>
  );
};

export default LoginPage; 